import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "7",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E14225",
      d: "M0 1.063 1.06.003l3.97 3.97L9 .003l1.06 1.06-5.03 5.03z"
    }, null, -1)
  ]))]))
}
export default { render: render }